module.exports = __webpack_public_path__ + "static/media/voucher_brandkit.9555816e.svg";